import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="relative flex min-h-[70vh] flex-col items-center justify-center px-4 text-center">
      <span className="flex h-16 w-16 items-center justify-center rounded-full bg-background-100 text-foreground-400">
        <i className="ri-compass-3-line text-3xl"></i>
      </span>
      <h1 className="mt-5 font-heading text-xl font-semibold text-foreground-900">页面走丢了</h1>
      <p className="mt-2 font-mono text-sm text-foreground-500">{location.pathname}</p>
      <p className="mt-2 text-sm text-foreground-500">你访问的页面不存在或已被移除，不如回首页看看有哪些好剧。</p>
      <div className="mt-5 flex flex-wrap items-center justify-center gap-3">
        <Link
          to="/"
          className="flex cursor-pointer items-center gap-1 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
        >
          <i className="ri-home-line"></i>
          返回首页
        </Link>
        <Link
          to="/category"
          className="flex cursor-pointer items-center gap-1 whitespace-nowrap rounded-md border border-background-300 px-4 py-2 text-sm text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-600"
        >
          <i className="ri-apps-2-line"></i>
          浏览剧集分类
        </Link>
      </div>
    </div>
  );
}